import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/tw-merge';

/** Centered content container on the design's 1200px grid + fluid gutter. */
export function UiContainer({
    width = '1440',
    className,
    children,
}: {
    width?: '760' | '1200' | '1440' | '1640';
    className?: string;
    children: ReactNode;
}) {
    const max = {
        '760': 'max-w-190',
        '1200': 'max-w-300',
        '1440': 'max-w-360',
        '1640': 'max-w-410',
    }[width];
    return (
        <div className={cn('ui-container mx-auto w-full px-(--space-gutter) py-(--space-section-96)', max, className)}>
            {children}
        </div>
    );
}
